import axios from 'axios';
import { BASE_URL } from '../components/Constant';

// eslint-disable-next-line no-undef
const auth = () => ({ headers: { authorization: localStorage.getItem('token') } });

const whatsappService = {
  conversations: () =>
    axios.get(`${BASE_URL}whatsapp/conversation`, auth()).then((response) => response.data?.data || []),
  history: (id, before) =>
    axios
      .get(`${BASE_URL}whatsapp/conversation/${encodeURIComponent(id)}`, { ...auth(), params: { before } })
      .then((response) => response.data?.data || { messages: [], nextCursor: null }),
  send: (to, displayName, body) =>
    axios.post(`${BASE_URL}whatsapp/send`, { to, displayName, body }, auth()).then((response) => response.data?.data)
};

export default whatsappService;
